import { ROOM_SERVICE_LOCATION_TYPES } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Stato',
      fields: {
        room_service_visible: {
          label: 'Servizio camera/tavolo visibile',
        },
        has_room_service: {
          label: 'Servizio camera/tavolo',
        },
      },
    },
    settings: {
      title: 'Impostazioni',
      table_number: {
        label: 'Mostra numero tavolo',
      },
    },
    locations: {
      title: 'Posizioni',
    },
  },
  form: {
    google_place: {
      label: 'Nome',
      placeholder: 'Nome su Google Maps',
    },
    type: {
      label: 'Tipo',
      options: {
        [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Servizio in camera',
        [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Servizio al tavolo',
      },
    },
    name: {
      label: 'Nome posizione',
      placeholder: 'Inserisci il nome della posizione comprensibile per il cliente',
    },
    street_name: {
      label: 'Via',
      placeholder: 'Nome via',
    },
    street_number: {
      label: 'Numero civico',
      placeholder: 'Numero civico',
    },
    city: {
      label: 'Città',
      placeholder: 'Città',
    },
    zip_code: {
      label: 'Codice postale',
      placeholder: 'Codice postale',
    },
  },
  fields: {
    id: 'id',
    type: 'Tipo',
    name: 'Nome',
    address: 'Indirizzo',
    is_active: 'Attivo',
  },
  room_service_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Servizio in camera',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Servizio al tavolo',
  },
  modals: {
    delete_location: {
      title: 'Sei sicuro?',
      description: 'Verrà eliminata la posizione «{{name}}»',
    },
  },
  buttons: {
    save: 'Salva',
    delete: 'Elimina',
  },
  toasts: {
    failed_to_load_locations: 'Caricamento posizioni non riuscito, ricarica la pagina',
    failed_to_create_location: 'Creazione posizione non riuscita',
    failed_to_toggle_location: 'Modifica disponibilità posizione non riuscita',
    failed_to_delete_location: 'Eliminazione posizione non riuscita',
    location_got_created: 'Posizione creata con successo',
    location_got_deleted: 'Posizione eliminata',
    saving_success: 'Salvato con successo',
    saving_error: 'Salvataggio non riuscito',
  },
};
